import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BaseComponent from '../../../baseClasses/BaseComponent';
import dataModel from '../../../models/DataModel';
import BuildDetailCard from './BuildDetailCard';
import './ProjectTemplateHierarchy.scss';
import animator from '../../../helpers/animator';
import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';
import { slide_down, slide_up, slide_in, slide_out } from '../../../helpers/animation_types.js';
import { build_root, attributes_build_root } from '../../../dao/BuildsDAO';
import DashboardProjectCard from '../../../components/DashboardProjectCard';
import ExpandableSection from '../../../components/ExpandableSection';
import MultiFileUploader from '../../../components/MultiFileUploader';
import DocumentsList from '../../../components/TaskCRUD/DocumentsList';
import ReferenceDocs from '../../../components/TaskCRUD/ReferenceDocs';
import ProjectTemplateHeader from '../../../containers/ProjectTypesContainer/ProjectTemplateHeader';

import DocumentsIcon from '../../../components/Iconoclast/DocumentsIcon';
import NewBuildCard from './NewBuildCard';
import styles from '../../../assets/styles/globals.scss';
import DataSource from '../../../dao/DataSource/DataSource';
import anime from 'animejs';

var inoutSpeed = 500;
var updownSpeed = 500;

const projectTemplateDescriptor = {
  project_template: {
    builds: {
      builds: {},
    },
    company: {},
    reference_documents: {},
    markets: {},
  },
};

class ProjectTemplateHierarchy extends BaseComponent {

  constructor(props) {
    super(props);

    this.state = {
      rerender: false, 
      scrollHeightDiffFromHeader: 0, 
      displayHeight: 0,
      projectTemplate: null,
    };

    this.animator = new animator();

    this.createExpandedProjectTemplateChildren = this.createExpandedProjectTemplateChildren.bind(this);
    this.createChildren = this.createChildren.bind(this);

    this.hasAnimated = false;
    this.mapInitialized = false;
    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
    });

    this.uploadReferenceDocument = this.uploadReferenceDocument.bind(this);
    this.deleteReferenceDocument = this.deleteReferenceDocument.bind(this);
  }

  handleUpdateProjectTemplate(projectTemplate, action, acData, fetchedData) {
    if (action == 'prefetch') {
      if ((!projectTemplate.builds || projectTemplate.builds.length == 0) && projectTemplate.builds_count > 0) {
        for (let i = 0; i < projectTemplate.builds_count - 1; i++) {
          projectTemplate.root_build.builds.push({ id: i * -1, inProgress: true, parent: projectTemplate, ancestry: projectTemplate.root_build_id });
        }
      }
      this.refreshStuff(projectTemplate);
      this.setState({ projectTemplate });
    }
    else {
      if (fetchedData && fetchedData.builds.length != projectTemplate.builds.length) {
        this.projectTemplateDataSource.get();
      }
      else if (acData && acData.type == 'updateProjectTemplate' && acData.sub_type == 'newBuild') {
        this.projectTemplateDataSource.get();
      }
      else {
        this.refreshStuff(projectTemplate);
        this.setState({ projectTemplate });
      }
    }
  }

  handleUpdateProjectType(projectType) {
    this.setState({ projectType });
  }

  handleInitializeDataSources() {
    if (this.projectTemplateDataSource) {
      this.projectTemplateDataSource.release();
    }
    if (this.projectTypeDataSource) {
      this.projectTypeDataSource.release();
    }

    const path = this.props.history.parseParameters();

    this.setState({ path });

    if (path.params.project_template_id) {
      this.projectTemplateDataSource = new DataSource('ProjectTemplate', +path.params.project_template_id, projectTemplateDescriptor, this.handleUpdateProjectTemplate);
      this.projectTemplateDataSource.get();
    }

    if (path.params.project_type_id) {
      this.projectTypeDataSource = new DataSource('ProjectType', +path.params.project_type_id, { project_type: {} }, this.handleUpdateProjectType);
      this.projectTypeDataSource.get();
    }
  }

  componentDidMount() {
    super.componentDidMount();

    if (this.scroller) {
      this.scroller.scrollTop = 0;
    }
    this.handleInitializeDataSources();
  }

  componentWillUnmount() {
    if (this.projectTemplateDataSource) {
      this.projectTemplateDataSource.release();
      this.projectTemplateDataSource = null;
    }
    if (this.projectTypeDataSource) {
      this.projectTypeDataSource.release();
      this.projectTypeDataSource = null;
    }
  }

  componentDidUpdate(prevProps) {
    if (this.scrollToRight && this.scroller) {
      this.scroller.scrollLeft = this.displayWidth;
      this.scrollToRight = false;
    }

    else if (this.scroller) {
      this.scroller.scrollTop = 0;
    }

    const path = this.props.history.parseParameters();
    if (this.state.path && path.params.project_template_id != this.state.path.params.project_template_id) {
      this.handleInitializeDataSources();
    }
  }

  createProjectTemplateStateMap(projectTemplate, items, parent) {
    if (items) {
      for (let j = 0; j < items.length; j++) {
        let item = items[j];
        if (!this.project_templateMap[item.id]) {
          this.mapInitialized = true;
          this.project_templateMap[item.id] = {
            expanded: false, animated: false, parent: parent, toggled: this.toggled,
          };
          if (!this.newMap && parent) {
            this.project_templateMap[parent.build ? parent.build.id : parent.id].expanded = true;
          }
        }
        else {
          this.project_templateMap[item.id].parent = parent;
          this.project_templateMap[item.id].toggled = this.toggled;
        }
        this.project_templateMap[item.id].id = item.id;
        this.project_templateMap[item.id].item = item;
        if (item.builds && item.builds.length > 0) {
          this.createProjectTemplateStateMap(projectTemplate, item.builds, item);
        }
      }
    }
  }

  createPositionsInStateMap(items) {
    for (let i = 0; i < items.length; i++) {
      let item = items[i];
      if (this.project_templateMap[item.id]) {
        const itemElement = document.getElementById('build-card-' + item.id);
        if (itemElement) {
          let itemRect = itemElement.getBoundingClientRect();
          this.project_templateMap[item.id].x = itemRect.left;
          this.project_templateMap[item.id].y = itemRect.top + this.scroller.scrollTop;
          this.project_templateMap[item.id].width = itemRect.width;
          this.project_templateMap[item.id].height = itemRect.height;
        }
      }
      if (item.builds) {
        this.createPositionsInStateMap(item.builds);
      }
    }
  }

  refreshStuff(projectTemplate) {
    if (projectTemplate) {
      if (projectTemplate && projectTemplate.root_build && projectTemplate.root_build.builds) {
        if (!this.project_templateMap) {
          this.project_templateMap = {};
          this.newMap = true;
        }
        this.toggled = !this.toggled;
        if (projectTemplate.root_build_id) {
          if (!this.mapInitialized) {
            this.newMap = true;
          }
          this.project_templateMap[projectTemplate.root_build_id] = {};
          this.createProjectTemplateStateMap(projectTemplate, projectTemplate.root_build.builds, null);
          this.project_templateMap[projectTemplate.root_build_id].expanded = true;
          this.project_templateMap[projectTemplate.root_build_id].toggled = this.toggled;
          for (let id in this.project_templateMap) {
            if (id) {
              if (this.project_templateMap[id].toggled != this.toggled) {
                delete this.project_templateMap[id];
              }
            }
          }
          this.newMap = false;
        }
        this.savedProjectTemplate = projectTemplate;
      }
      else {
        this.project_templateMap = {};
        this.newMap = true;
        if (projectTemplate && projectTemplate.root_build_id) {
          this.project_templateMap[projectTemplate.root_build_id] = {};
          this.createProjectTemplateStateMap(projectTemplate, projectTemplate.root_build.builds, null);
          this.project_templateMap[projectTemplate.root_build_id].expanded = true;
        }
      }
      if (!projectTemplate.published_at && !projectTemplate.publishing) {
        this.setState({ banner: 'This Version has not yet been published.' });
      } else {
        this.setState({ banner: null });
      }
    }
  }

  collapseChildren(builds, animated) {
    if (builds) {
      let animationHorizontalGroup = [];
      let animationVerticalGroup = [];
      let groupAdded = false;
      let addAdded = false;

      for (var i = 0; i < builds.length; i++) {
        const build = builds[i];

        if (animated && this.project_templateMap[build.id] && this.project_templateMap[build.id].parent) {
          const parent = this.project_templateMap[build.id].parent;

          if (!addAdded) {
            addAdded = true;
            const addId = 'new-build-card-' + parent.id;

            let slideOutAni = this.animator.createAnimation(slide_out, addId, inoutSpeed, false, 25, -221);
            animationHorizontalGroup.push(slideOutAni);
            const element = document.getElementById(addId);
            if (element) {
              const itemTop = element.style.top;
              const intTop = parseInt(itemTop.replace('px', ''), 10);

              if (intTop > 0) {
                let vertId = 'vertical-connector-' + parent.id;
                let slideUpAni = this.animator.createAnimation(slide_up, addId, updownSpeed, false, intTop, 0, vertId);
                animationVerticalGroup.push(slideUpAni);
              }
              if (!groupAdded) {
                groupAdded = true;
                this.animator.addCollection(animationHorizontalGroup, true);
                this.animator.addCollection(animationVerticalGroup, true);
              }
            }
          }
          const id = 'build_' + build.id + '_' + (build.order ? build.order : '') + parent.id;

          let slideOutAni = this.animator.createAnimation(slide_out, id, inoutSpeed, false, 25, -221);
          animationHorizontalGroup.push(slideOutAni);
          const element = document.getElementById(id);
          if (element) {
            const itemTop = element.style.top;
            const intTop = parseInt(itemTop.replace('px', ''), 10);

            if (intTop > 0) {
              let vertId = 'vertical-connector-' + parent.id;
              let slideUpAni = this.animator.createAnimation(slide_up, id, updownSpeed, false, intTop, 0, vertId);
              animationVerticalGroup.push(slideUpAni);
            }
            if (!groupAdded) {
              groupAdded = true;
              this.animator.addCollection(animationHorizontalGroup, true);
              this.animator.addCollection(animationVerticalGroup, true);
            }
          }
        }
        if (this.project_templateMap[build.id].toExpand) {
          this.collapseChildren(build.builds, animated);
        }
        this.project_templateMap[build.id].toExpand = false;
        this.project_templateMap[build.id].expanded = false;
      }
    }
  }

  collapseSiblings(item, animated) {
    let parent = this.project_templateMap[item.id].parent;
    if (!parent) {
      parent = this.state.projectTemplate;
    }
    let builds = null;
    if (parent.root_build_id) {
      builds = this.state.projectTemplate.root_build.builds;
    }
    else {
      builds = parent.builds;
    }
    if (builds) {
      for (var i = 0; i < builds.length; i++) {
        const build = builds[i];
        if (build.id != item.id) {
          if (!this.project_templateMap[build.id]) {
            this.project_templateMap[build.id] = { expanded: false, animated: false, parent: parent, toggled: this.toggled };
          }
          else if (this.project_templateMap[build.id].toExpand) {
            this.collapseChildren(build.builds, animated);
          }
          this.project_templateMap[build.id].toExpand = false;
          this.project_templateMap[build.id].expanded = false;
        }
      }
      if (parent != this.state.projectTemplate) {
        this.collapseSiblings(parent, animated);
      }
    }
  }

  findParentOfBuild(build, projectTemplate) {
    // Traverse ancestry to find  build
    const ancestry = build.ancestry.split('/');
    let buildToSearch = projectTemplate.root_build.builds[0];
    if (buildToSearch) {
      return null;
    }
    let buildIdToFind = ancestry.shift();
    while (ancestry.length) {
      buildIdToFind = ancestry.shift();
      // eslint-disable-next-line no-loop-func
      buildToSearch = buildToSearch.builds.find(build => build.id == +buildIdToFind); 
    }
    return buildToSearch;
  }

  handleBuildDeletion(deletedBuild) {
    const projectTemplate = Object.assign({}, this.state.projectTemplate);
    const deletedBuildsParent = this.findParentOfBuild(deletedBuild, projectTemplate);
    const deletedBuildIndex = deletedBuildsParent.builds.findIndex(build => build.id == deletedBuild.id);
    if (deletedBuildIndex >= 0) {
      deletedBuildsParent.builds.splice(deletedBuildIndex, 1);
      this.setState(projectTemplate);
    }
  }

  handleFindColumn(x) {
    for (let id in this.project_templateMap) {
      if (id) {
        const item = this.project_templateMap[id];
        if (item.width && x >= item.x && x <= (item.x + item.width)) {
          return x;
        }
      }
    }
  }

  handleFindDragTarget(y) {
    if (this.dragX) {
      const normalizedY = y + this.outerScroll.scrollTop;
      let firstInList = true;
      for (let i = 0; i < this.orderedDragList.length; i++) {
        let id = this.orderedDragList[i].id;
        if (id) {
          const item = this.project_templateMap[id];
          const element = document.getElementById('build-card-' + id);
          if (element) {
            const rect = element.getBoundingClientRect();
            if (firstInList && normalizedY < rect.top && normalizedY <= (rect.top + rect.height / 2)) {
              this.dragBefore = true;
              return item;
            }
            else if (normalizedY >= rect.top && normalizedY <= (rect.top + rect.height)) {
              this.dragBefore = false;
              return item;
            }
            firstInList = false;
          }
        }
      }
    }
  }

  handleCreateDragIndicator() {
    this.lineElement = document.createElement('div');
    this.lineElement.style.width = '219px';
    this.lineElement.style.height = '6px';
    this.lineElement.style.backgroundColor = '#a7a7a7';
    this.lineElement.style.position = 'absolute';
    this.lineElement.style.zIndex = 999;
    this.container.appendChild(this.lineElement);
  }

  handlePositionDragIndicator() {
    if (this.container) {
      const containerRect = this.container.getBoundingClientRect();
      let top = (this.dragTarget.y - containerRect.top - this.scroller.scrollTop) + this.dragTarget.height - 10;
      if (this.dragBefore) {
        top = this.dragTarget.y - this.dragTarget.height - 8;
      }
      this.lineElement.style.top = top + 'px';
      this.lineElement.style.left = (this.dragTarget.x - containerRect.left) + 'px';
    }
  }

  handleDragging(build, x, y) {
    // Start in one column, and stay in that column
    if (!this.dragX) {
      this.orderedDragList = [];
      for (let id in this.project_templateMap) {
        if (id) {
          if (this.project_templateMap[id].item) {
            this.orderedDragList.push(this.project_templateMap[id]);
          }
        }
      }
      this.orderedDragList.sort((i1, i2) => {
        if (i1.item.order < i2.item.order) {
          return -1;
        }
        else if (i1.item.order > i2.item.order) {
          return 1;
        }
        else {
          return 0;
        }
      });
      this.createPositionsInStateMap(this.state.projectTemplate.root_build.builds);
      this.dragX = this.handleFindColumn(x);
      this.dragTarget = this.handleFindDragTarget(y);
      this.handleCreateDragIndicator();
      if (this.dragTarget) {
        this.handlePositionDragIndicator();
      }
    }
    else {
      const newDragTarget = this.handleFindDragTarget(y);
      if ((newDragTarget && newDragTarget != this.dragTarget) || this.dragBefore) {
        this.dragTarget = newDragTarget;
        this.handlePositionDragIndicator();
      }
    }
    if (this.dragTarget && this.scroller) {
      const scrollerRect = this.scroller.getBoundingClientRect();
      if (y  + 20 + this.dragTarget.height > scrollerRect.bottom) {
        this.scroller.scrollTop += (y + 20 + this.dragTarget.height) - scrollerRect.bottom;
      }
      else if (y < scrollerRect.top) {
        this.scroller.scrollTop-= Math.abs(y - scrollerRect.top);
      }
    }
  }

  handleDragFinished() {
    if (this.lineElement) {
      this.container.removeChild(this.lineElement);
    }
    delete this.dragX;
    delete this.lineElement;
    delete this.dragTarget;
  }

  orderBuilds(builds, afterBuild, insertedBuild, orderedBuilds) {
    let order = 1;
    if (!afterBuild) {
      insertedBuild.order = order++;
      orderedBuilds.push(insertedBuild);
      for (let i = 0; i < builds.length; i++) {
        const copyBuild = builds[i];
        if (copyBuild.id != insertedBuild.id) {
          copyBuild.order = order++;
          orderedBuilds.push(copyBuild);
        }
      }
    }
    else {
      for (let i = 0; i < builds.length; i++) {
        const copyBuild = builds[i];
        if (copyBuild.id != insertedBuild.id) {
          copyBuild.order = order++;
          orderedBuilds.push(copyBuild);
          if (copyBuild.id == afterBuild.id) {
            insertedBuild.order = order++;
            orderedBuilds.push(insertedBuild);
          }
        }
      }
    }
  }

  handleDropping(build, x, y) {
    if (this.dragTarget) {
      let afterBuild = this.dragBefore ? null : this.dragTarget.item;
      if ((afterBuild && afterBuild.id != build.id) || !afterBuild) {
        const parent = this.project_templateMap[build.id].parent ? Object.assign({}, this.project_templateMap[build.id].parent) : this.state.projectTemplate;
        if (parent && parent.builds) {
          this.sortBuilds(parent.builds);
          let reorderedBuilds = [];
          this.orderBuilds(parent.ancestry ? parent.builds :parent.builds.length > 0 ? parent.builds : [build], afterBuild, build, reorderedBuilds);
          dataModel.buildsDAO.reorderBuilds(reorderedBuilds, null, this.state.projectTemplate);
        }
      }
    }
    this.handleDragFinished();
  }

  handleDragCancel() {
    this.handleDragFinished();
  }

  sortBuilds(builds) {
    builds.sort((t1, t2) => {
      if (t1.order && !t2.order) {
        return -1;
      }
      else if (!t1.order && t2.order) {
        return 1;
      }
      else if (t1.order && t2.order) {
        if (t1.order < t2.order) {
          return -1;
        }
        else if (t1.order > t2.order) {
          return 1;
        }
        else {
          return 0;
        }
      }
      else if (t1.id < t2.id) {
        return -1;
      }
      else if (t1.id > t2.id) {
        return 1;
      }
      else return 0;
    });
  }

  createChildren(parent, builds, left, top, animated) {
    if (builds) {

      // sort the builds
      this.sortBuilds(builds);
    }
    this.project_templateMap[parent.id ? parent.id : parent].expanded = true;
    let usedBuilds = builds || [];
    let verticalExpandedCardGroup = [];
    let animationHorizontalGroup = [];
    let animationVerticalGroup = [];
    let columnHeight = 0;
    let expandedBuild = null;
    let internalTop = 0;
    let expandedTop = 0;

    //*************************************************
    //
    //  Create the list of individual builds that will
    //  be in the column
    //
    //*************************************************
    let firstBuild = true;
    let numBuilds = usedBuilds.length;
    const buildList = usedBuilds.map((build) => {
      if (!build || !build.ancestry) {
        return null;
      }
      let displayTop = internalTop;
      const buildHeight = 114;
      internalTop += buildHeight + 34;
      this.detailHeight = Math.max(this.detailHeight, internalTop);
      if (this.project_templateMap[build.id] && this.project_templateMap[build.id].toExpand) {
        expandedBuild = build;
        expandedTop = displayTop;
      }

      const id = 'build_' + build.id + '_' + (build.order ? build.order : '') + (parent.id ? parent.id : parent);
      if (animated) {
        let slideInAni = this.animator.createAnimation(slide_in, id, inoutSpeed, true, -221, 25);

        animationHorizontalGroup.push(slideInAni);

        if (displayTop != 0) {
          let slideDownAni = this.animator.createAnimation(slide_down, id, updownSpeed, false, 0,
            displayTop, 'vertical-connector-' + (parent.id ? parent.id : parent));
          animationVerticalGroup.push(slideDownAni);
        }
        displayTop = 0;
      }

      const connectorClass = firstBuild ? 'horizontal-connector' : 'half-horizontal-connector';
      firstBuild = false;
      columnHeight += buildHeight + 34;
      this.containerHeight = Math.max(this.containerHeight, columnHeight);

      return (
        <div id={id} key={id}
          className="class-detail-card"
          style={{ left: animated ? - 221 : 25, top: displayTop }}>
          <hr className={connectorClass} />
          <BuildDetailCard
            id={'build-card-' + build.id}
            left={0}
            top={5}
            buildId={build.id}
            project_template={this.state.projectTemplate}
            handleBuildExpand={this.handleBuildCardExpand}
            expanded={build && this.project_templateMap[build.id] && this.project_templateMap[build.id].toExpand}
            onDeleteBuild={this.handleBuildDeletion}
            selectBuild={this.handleBuildSelection}
            handleDragging={this.handleDragging}
            handleDropping={this.handleDropping}
            handleDragCancel={this.handleDragCancel}
            readOnly={!!this.state.projectTemplate.published_at}
            dragParentId={'project_template-card-container'}
            isDialog={true}
          />
        </div>
      );
    });
      
    let newCard;
    if (!expandedBuild && this.props.permissions.canEditProjectTemplate && !this.state.projectTemplate.published_at) {
      const connectorClass = buildList.length > 0 ? 'half-horizontal-connector' : 'horizontal-connector';
      let id = 'new-build-card-' + (parent.id ? parent.id : parent);
      newCard = <NewBuildCard 
        id={id} 
        key={id} 
        connectorClass={connectorClass}
        left={animated ? -221 : 25} 
        top={animated ? 5 : internalTop} 
        type='build' 
        width={219} 
        height={141}
        handleCreate={this.handleCreateBuild} 
        parent={parent} 
      />;
      columnHeight += 134;
      numBuilds++;
      if (animated) {
        let slideInAni = this.animator.createAnimation(slide_in, id, inoutSpeed, true, -221, 25);

        animationHorizontalGroup.push(slideInAni);
        if (internalTop != 0) {
          let slideDownAni = this.animator.createAnimation(slide_down, id, updownSpeed, false, 0,
            internalTop, 'vertical-connector-' + (parent.id ? parent.id : parent));
          animationVerticalGroup.push(slideDownAni);
        }
      }
    }

    //*************************************************
    //
    // Add the expansion animations (out and down)
    //
    //*************************************************
    if (verticalExpandedCardGroup.length > 0) {
      this.animator.addCollection(verticalExpandedCardGroup, true);
    }
    if (animated) {
      this.animator.addCollection(animationVerticalGroup, false);
      this.animator.addCollection(animationHorizontalGroup, true);
    }
    //*************************************************
    //
    // Create the column that contains the builds
    //
    //*************************************************
    const minHeight = window.innerHeight - this.state.scrollHeightDiffFromHeader - 167;
    const style = { left: left - 25, top: top, height: columnHeight ? columnHeight < minHeight ? minHeight : columnHeight + 40 : minHeight , width: 291 };
    this.displayWidth = left + 291 + 25;
    let connectorStyle = { top: 27, height: (animated || numBuilds == 1 ? 0 : (columnHeight - (!newCard ? 147 : 134))) };
    if (numBuilds <= 1) {
      connectorStyle = { display: 'none' };
    }
    const childNode =
      <div id={'column-' + (parent.id ? parent.id : parent)} className="child-column build-column" style={style}
        key={'column-' + (parent.id ? parent.id : parent)} >
        <hr id={'vertical-connector-' + (parent.id ? parent.id : parent)} className="vertical-connector" style={connectorStyle} />
        {buildList}
        <hr className='horizontal-connector' />
        {newCard}
      </div>;

    //************************************************* 
    //
    // Create the next column over if there is an  
    // expanded build in this column
    //
    //*************************************************
    let nodeArray = [childNode];
    if (expandedBuild) {
      const nextChildNode = this.createChildren(expandedBuild, expandedBuild.builds, left + 219 + 25,
        top + expandedTop, !this.project_templateMap[expandedBuild.id].expanded);
      if (nextChildNode != -1) {
        nodeArray.push(nextChildNode);
      }
    }

    //************************************************* 
    //
    // Animate the expansion if required
    //
    //*************************************************
    if (animated) {
      let _this = this;
      setTimeout(function() {
        _this.animator.processAnimationQueue(() => {
        });
      }, 10);
    }
    return nodeArray;
    
  }

  createExpandedProjectTemplateChildren(projectTemplate) {
    if (!this.project_templateMap || !projectTemplate || !this.project_templateMap[projectTemplate.root_build_id]) {
      return null;
    }
    const left = 256 + 25;
    const top = 32;
    this.containerHeight = 0;
    if (this.props.permissions && this.props.permissions.canViewTask) {
      const project_templateChildren = this.createChildren(projectTemplate.root_build_id, projectTemplate.root_build.builds, left, top, false);
      this.dontAnimate = false;
      if (this.scroller) {
        this.scroller.scrollTop = 0;
      }
      return project_templateChildren;
    }
    else {
      return null;
    }
  }

  handleBuildCardExpand(build, callback) {

    // save this one in the parent as it will be more complete
    if (this.project_templateMap[build.id].parent) {
      this.project_templateMap[build.id].parent.builds = this.project_templateMap[build.id].parent.builds.map((child) => {
        if (child.id == build.id) {
          return build;
        }
        else {
          return child;
        }
      });
    } 

    if (this.animator.animationLock) {
      return;
    }
    this.project_templateMap[build.id].toExpand = !this.project_templateMap[build.id].toExpand;
    let saveExpand = this.project_templateMap[build.id].toExpand;

    if (!this.project_templateMap[build.id].toExpand) {
      this.collapseChildren(build.builds, true, this.animator);
    }
    else {
      this.scrollToRight = true;
      this.collapseSiblings(build, true, this.animator);
    }
    this.project_templateMap[build.id].toExpand = saveExpand;
    this.project_templateMap[build.id].expanded = false;

    if (this.animator.hasAnimations) {
      this.animator.processAnimationQueue(() => {
        if (callback) {
          callback();
        }
        if (this.scroller) {
          this.scroller.scrollTop= 0;
        }
        // Trigger the re-render by toggling the state
        this.setState({
          rerender: !this.rerender, userAssignmentPopup: null, companyAssignmentPopup: null,
        });
      });
    }
    else {
      if (this.scroller) {
        this.scroller.scrollTop= 0;
      }
      this.setState({
        rerender: !this.rerender, userAssignmentPopup: null, companyAssignmentPopup: null,
      });
    }
  }

  handleBuildSelection(build) {
    const { projectTemplate } = this.state;
    this.props.history.push('/project-types/' + projectTemplate.project_type_id + '/project-template/' + projectTemplate.id + '/build/' + build.id);
  }

  async handleCreateBuild(build, parent) {
    if (build.name) {
      if (typeof parent == 'number') {
        parent = await dataModel.buildsDAO.getBuild(parent, { recordDescriptor: attributes_build_root });
      }

      const newBuild = {
        name: build.name,
        user_build_assignments: build.user_build_assignments,
        ancestry: (parent.ancestry ? parent.ancestry + '/' : '') + parent.id,
        location_id: null,
      };
      const createdBuild = await dataModel.buildsDAO.createBuild(newBuild, null, { recordDescriptor: build_root });
      if (createdBuild) {
        const projectTemplate = Object.assign({}, this.state.projectTemplate);
        const addedBuildsParent = this.findParentOfBuild(createdBuild, projectTemplate);
        const buildAlreadyExists = addedBuildsParent && addedBuildsParent.builds.find(build => build.id == createdBuild.id);
        if (!buildAlreadyExists && addedBuildsParent) {
          addedBuildsParent.builds.push(createdBuild);
          this.setState({ projectTemplate });
        }
      }
    }
    dataModel.dataChanged = false;
  }

  handleProjectTemplateSelection(build, onComplete, breadCrumbList) {
    const { projectTemplate } = this.state;

    this.props.history.push('/project-types/' + projectTemplate.project_type_id + '/project-template/' + projectTemplate.id + '/build/all');
  }

  async uploadReferenceDocument(file) {
    const document = {
      attachment: file,
      name: file.name,
    };
    this.analyticsLogger.logRDLGenericEvent('RDTemplateUpload');
    const results = await dataModel.referenceDocumentsDAO.createReferenceDocument(document, true);
    if (results && results.id) {
      const updatedProjectTemplate = await dataModel.projectTemplatesDAO.addReferenceDocument(results.id, this.state.projectTemplate.id, null, { recordDescriptor: projectTemplateDescriptor });
      this.setState({ projectTemplate: updatedProjectTemplate });
    }
  }

  deleteReferenceDocument(docId) {
    const { projectTemplate } = this.state;
    dataModel.showGlobalModal('SYSTEM_POPUP', {
      width: 320,
      height: 184,
      message: 'Are you sure you want to delete this Reference Document?',
      cancelButtonText: 'No',
      okButtonText: 'Yes',
      handleOwnerOk: () => {
        this.analyticsLogger.logRDLGenericEvent('RDTemplateDeleted');
        const document = projectTemplate.reference_documents.find(doc => doc.id == docId);
        projectTemplate.reference_documents = projectTemplate.reference_documents.filter(doc => doc.id != docId);
        this.setState({ projectTemplate });
        dataModel.projectTemplatesDAO.removeReferenceDocument(docId, projectTemplate.id).catch(error => {
          // roll back the delete
          projectTemplate.reference_documents.push(document);
          this.setState({ projectTemplate });
        });
      },
    });
  }

  handleProjectGanttExpandContract(expanded) {
    if (expanded) {
      this.setState({ internalprojectGanttExpanded: true });
      anime({
        targets: '.project_template-card-scroller',
        height: 0,
        easing: 'easeInOutCubic',
        duration: 500,
        complete: () => {
          this.setState({ preprojectGanttExpanded: true });
          this.setState({ internalprojectGanttExpanded: true });
        },
      });
      anime({
        delay: 10,
        targets: '.project-template-gantt-chart',
        width: (window.innerWidth - 250),
        easing: 'easeInOutCubic',
        duration: 500,
      });
      anime({
        delay: 10,
        targets: '.project-template-gantt-chart',
        height: 260,
        easing: 'easeInOutCubic',
        duration: 500,
        complete: () => {
          this.setState({ projectGanttExpanded: true });
        },
      });
    }
    else {
      let height = window.innerHeight - 270;
      anime({
        targets: '.project_template-card-scroller',
        height: height,
        easing: 'easeInOutCubic',
        duration: 500,
        complete: () => {
          this.setState({ preprojectGanttExpanded: false });
        },
      });
      anime({
        targets: '.project-template-gantt-chart',
        height: 65,
        easing: 'easeInOutCubic',
        duration: 500,
      });
      anime({
        targets: '.project-template-gantt-chart',
        width: 554,
        easing: 'easeInOutCubic',
        duration: 500,
        complete: () => {
          this.setState({ projectGanttExpanded: false, internalprojectGanttExpanded: false });
        },
      });
    }
  }

  render() {
    let { projectTemplate, projectType, banner } = this.state;

    if (!projectTemplate || !projectType) {
      return null;
    }

    //***************************************************
    // Render everything
    //***************************************************    

    let project_templateChildren = null;
    if (projectTemplate) {
      project_templateChildren = this.createExpandedProjectTemplateChildren(projectTemplate);

      if (project_templateChildren == -1 || this.state.project_templateChildren) {
        project_templateChildren = null;
      }
    }
    if (!this.hasAnimated) {
      this.hasAnimated = true;

    }

    let ganttStyle = { height: this.state.projectGanttExpanded ? window.innerHeight - 132 : 64 };

    return (
      <div className={'project_template-hierarchy ' + (this.props.wontAnimate ? 'wontAnimate' : '')} id={this.props.id}>
          <ProjectTemplateHeader
          history={this.props.history}
          projectTemplate={projectTemplate}
          projectType={projectType}
          currentCompany={this.props.currentCompany}
          currentUser={this.props.currentUser}
          />
        {banner && <div className="project-types-banner">{banner}</div>}
        <div 
          id="project_template-detail" 
          className={'project_template-detail' + (!projectTemplate.published_at && !projectTemplate.publishing ? ' not-published' : '')}
          ref={(element) => { this.outerScroll = element; }}
        >
          <div 
            id="project_template-detail-scroller" 
            className={'project_template-card-scroller' + (!projectTemplate.published_at && !projectTemplate.publishing ? ' not-published' : '')}
            ref={(element) => { this.scroller = element; }}
          >
            <div className="project_template-card-container" id="project_template-card-container" ref={(element) => { this.container = element; }}>
            <DashboardProjectCard 
            projectTemplate={projectTemplate}
            left={0}
            top={32}
            width={256}
            height={136}
            handleCardClick={this.handleProjectTemplateSelection}
            displayDocuments={true}
              />
                <ExpandableSection name="REFERENCE DOCUMENTS">
                {!projectTemplate.published_at &&
                  <ReferenceDocs projectTemplate={projectTemplate} editing={true} build={this.props.build} />
                }
                  {!projectTemplate.published_at &&
                    <MultiFileUploader
                    backgroundIcon={<DocumentsIcon iconColor={styles.lightElement} />}
                    handleFileSelect={this.uploadReferenceDocument}
                    hasInlineLoader={true}
                  />}
                  <DocumentsList
                    documentType='reference'
                    documents={projectTemplate.reference_documents}
                    canDeleteDocuments={true}
                    handleDeleteDocument={this.deleteReferenceDocument}
                  />
                </ExpandableSection>
              {project_templateChildren}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// Change to appropriate class name

const mapStateToProps = (state, ownProps) => {
  return {
    inProgress: state.main.inProgress,
    dataModel: dataModel,
    permissions: state.new_users ? state.new_users.permissions : null,
    currentUser: state.new_users.currentUser,
    currentCompany: state.new_companies.currentCompany,
  };
};

export default connect(mapStateToProps, null)(withRouter(ProjectTemplateHierarchy));



// WEBPACK FOOTER //
// ./src/containers/ProjectTemplatesContainer/ProjectTemplateHierarchy/index.js